import type { IconSvgObject } from './types';

const ChevronLeftIcon: IconSvgObject = [
  ["path", { d: "M15 6L9 12L15 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ChevronLeftIcon;
